import { render, staticRenderFns } from "./insuresuccess.vue?vue&type=template&id=5b1184d0&scoped=true&"
import script from "./insuresuccess.vue?vue&type=script&lang=js&"
export * from "./insuresuccess.vue?vue&type=script&lang=js&"
import style0 from "./insuresuccess.vue?vue&type=style&index=0&id=5b1184d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1184d0",
  null
  
)

export default component.exports